
export default {
    retentions: [
        {
            type: "FTE",
            // Prod
            prod_vr_limit: 0,
            new_prod_vr_limit: 0,
            prod_percentage: 0.0,
            new_prod_percentage: 0.0,
            // Serv
            serv_vr_limit: 0,
            new_serv_vr_limit: 0,
            serv_percentage: 0.0,
            new_serv_percentage: 0.0,


        },
        {
            type: "IVA",
            // Prod
            prod_vr_limit: 0,
            new_prod_vr_limit: 0,
            prod_percentage: 0,
            new_prod_percentage: 0,
            // Serv
            serv_vr_limit: 0,
            new_serv_vr_limit: 0,
            serv_percentage: 0.0,
            new_serv_percentage: 0.0,
        },
        {
            type: "ICA",
            // Prod
            prod_vr_limit: 0,
            new_prod_vr_limit: 0,
            prod_percentage: 0,
            new_prod_percentage: 0,
            // Serv
            serv_vr_limit: 0,
            new_serv_vr_limit: 0,
            serv_percentage: 0.0,
            new_serv_percentage: 0.0,
        }
    ],
    retentionsProvider: [
        {
            type: "FTE",
            // Prod
            prod_vr_limit: 0,
            new_prod_vr_limit: 0,
            prod_percentage: 0.0,
            new_prod_percentage: 0.0,

            serv_vr_limit: 0,
            new_serv_vr_limit: 0,
            serv_percentage: 0.0,
            new_serv_percentage: 0.0,


        },
        {
            type: "IVA",
            // Prod
            prod_vr_limit: 0,
            new_prod_vr_limit: 0,
            prod_percentage: 0.0,
            new_prod_percentage: 0.0,
            // Serv
            serv_vr_limit: 0,
            new_serv_vr_limit: 0,
            serv_percentage: 0.0,
            new_serv_percentage: 0.0,
        },
        {
            type: "ICA",
            // Prod
            prod_vr_limit: 0,
            new_prod_vr_limit: 0,
            prod_percentage: 0.0,
            new_prod_percentage: 0.0,
            // Serv
            serv_vr_limit: 0,
            new_serv_vr_limit: 0,
            serv_percentage: 0.0,
            new_serv_percentage: 0.0,
        }
    ],
    type_contact: 1
}



// WEBPACK FOOTER //
// ./src/modules/update-withholdings/state.js